export default __webpack_public_path__ + "static/media/bg-pattern-intro-right-desktop.0c130b3f.svg";